import React from 'react';
import { ShoppingCart, Minus, Plus, Trash2, CreditCard, Package } from 'lucide-react';

export default function Cart({ cart, cartTotal, onUpdateQuantity, onRemoveFromCart, onContinueShopping, onCheckout }) {
  if (cart.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold mb-6">Shopping Cart</h2>
        <div className="text-center py-12">
          <ShoppingCart size={64} className="mx-auto text-gray-300 mb-4" />
          <p className="text-gray-500 text-lg">Your cart is empty</p>
          <button
            onClick={onContinueShopping}
            className="mt-4 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-6">Shopping Cart ({cart.length} {cart.length === 1 ? 'item' : 'items'})</h2>
      
      <div className="space-y-4 mb-6">
        {cart.map(item => (
          <div key={item.id} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
            <div className="w-16 h-16 bg-gray-100 rounded flex items-center justify-center flex-shrink-0">
              {item.image ? (
                <img src={item.image} alt={item.name} className="w-full h-full object-cover rounded" />
              ) : (
                <Package size={32} className="text-gray-300" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold truncate">{item.name}</h3>
              <p className="text-gray-600">${item.price}</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => onUpdateQuantity(item.id, -1)}
                className="p-1 hover:bg-gray-100 rounded"
              >
                <Minus size={16} />
              </button>
              <span className="w-8 text-center font-semibold">{item.quantity}</span>
              <button
                onClick={() => onUpdateQuantity(item.id, 1)}
                className="p-1 hover:bg-gray-100 rounded"
              >
                <Plus size={16} />
              </button>
            </div>
            <div className="font-semibold w-20 text-right">
              ${(item.price * item.quantity).toFixed(2)}
            </div>
            <button
              onClick={() => onRemoveFromCart(item.id)}
              className="p-2 hover:bg-red-50 text-red-600 rounded"
            >
              <Trash2 size={20} />
            </button>
          </div>
        ))}
      </div>

      <div className="border-t pt-4">
        <div className="flex justify-between items-center mb-6">
          <span className="text-xl font-semibold">Total:</span>
          <span className="text-2xl font-bold text-red-600">${cartTotal.toFixed(2)}</span>
        </div>
        <div className="flex gap-4">
          <button
            onClick={onContinueShopping}
            className="flex-1 bg-gray-200 text-gray-700 px-6 py-3 rounded-lg hover:bg-gray-300 font-semibold"
          >
            Continue Shopping
          </button>
          <button
            onClick={onCheckout}
            className="flex-1 bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 font-semibold flex items-center justify-center gap-2"
          >
            <CreditCard size={20} />
            Proceed to Checkout
          </button>
        </div>
      </div>
    </div>
  );
}